import React, {
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";

import { Button, Form, Icon, Label, Segment, TextArea } from "semantic-ui-react";
import { useIntl } from "react-intl";

const style = {
  paddingTop: { paddingTop: "20px" },
};

interface SubDifferentialDiagnosisProps {
  onSaveAllCallback?: () => void;
  isReadOnly?: boolean;
  titleCard: string
}

const DEFAULT_PROPS = {
  titleCard: "Differential Diagnosis",

  onSaveAllCallback: () => {},

  isReadOnly: false,
}
const SubDifferentialDiagnosis = forwardRef<any,SubDifferentialDiagnosisProps>((propsParam, ref) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };

  const [detail, setDetail] = useState<string>("");

  const { titleCard, isReadOnly } = props;

  useImperativeHandle(ref, () => ({
    getSaveData: () => {
      return { detail: detail };
    },
    setData: (data: any) => {
      setDetail(data?.detail || "");
    },
  }));

  return (
    <Segment raised secondary>
      <Label color="grey" ribbon size="big">
        {titleCard}
      </Label>

      <Form style={style.paddingTop}>
        <Form.Group inline>
          <Form.Field width={16}>
          <TextArea
            style={{ resize: "none", width: "100%", padding: "10px" }}
            rows={2}
            readOnly={isReadOnly}
            placeholder={"Investigation Results"}
            onChange={(e) => {
              setDetail(e.target.value);
            }}
            value={detail}
          />
          </Form.Field>
        </Form.Group>

        <Form.Group inline>
          <Form.Field width={1}>
            <Button
              color="green"
              type="button"
              onClick={props.onSaveAllCallback}
            >
              {props.saveText ? <Icon className="check"></Icon> : "บันทึก"}
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>
    </Segment>
  );
});

SubDifferentialDiagnosis.displayName = "SubDifferentialDiagnosis"

export default React.memo(SubDifferentialDiagnosis);
